import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconFilter(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M4 5a1 1 0 0 0 0 2h16a1 1 0 1 0 0-2H4Zm3 4a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H7Zm2 5a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Zm3 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
